/**
 * The platform's own identity, used wherever no tenant has been resolved.
 *
 * Exists because the fallbacks used to be one customer's: an unmapped host rendered RGPS's logo and
 * the browser tab said "Vite + React + TS". Neither is shippable to a second customer, and the first
 * is arguably worse than the placeholder — it shows one school's brand to another's users.
 */
export const PLATFORM_BRAND = {
  name: "Trovix Campus",
  /** Served from /public, so it resolves before any bundle has executed. */
  faviconHref: "/favicon.svg",
  logoSrc: "/platform-logo.svg",
} as const;
